// extracted by mini-css-extract-plugin
export default {"TextArea":"InputTextArea_TextArea__VlmVO"};